import { FloatButton, Layout } from 'antd';
import { PlatformTreeView } from './components/PlatformRuleVisualization';
// import { Content, Header } from 'antd/es/layout/layout';
const { Header, Footer, Content } = Layout;

const footerStyle: React.CSSProperties = {
  textAlign: 'center',
  color: '#fff',
  backgroundColor: '#041528',
  // backgroundColor: '#4096ff',
};
const headerStyle: React.CSSProperties = {
  color: 'white',
  textAlign: 'left',
  fontSize: '24px',
};

const contentStyle: React.CSSProperties = {
  // paddingTop: '30px',
  // paddingBottom: '30px'
};

function App() {
  return (
    <div className="App">
      <Layout>
        {/* <Header style={headerStyle}>生命周期联动规则</Header> */}
        <Content style={contentStyle}>
          <PlatformTreeView />
          <FloatButton.Group shape="circle" style={{ insetInlineEnd: 60 }}>
            {<FloatButton.BackTop visibilityHeight={400} />}
          </FloatButton.Group>
        </Content>
        <Footer style={footerStyle}></Footer>
      </Layout>
    </div>
  );
}

export default App;
